export default function StatusSection({ data, onChange }) {
  return (
    <>
      <div>
        <label className="mb-1 block text-sm font-medium">
          Status
        </label>
        <select
          name="status"
          value={data.status}
          onChange={onChange}
          className="w-full rounded-xl border border-gray-300 p-3"
        >
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>

      <div className="flex items-center gap-2 pt-2">
        <input
          type="checkbox"
          name="eco_friendly"
          checked={data.eco_friendly}
          onChange={(e) =>
            onChange({
              target: {
                name: "eco_friendly",
                value: e.target.checked,
              },
            })
          }
          className="h-4 w-4 rounded border-gray-300"
        />
        <label className="text-sm font-medium">
          Eco Friendly
        </label>
      </div>
    </>
  );
}
